import { Link } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";
import { track } from "../lib/analytics";

const DEFAULT_BENEFITS = [
  "Small class sizes",
  "Hands-on learning",
  "Beginner friendly",
  "Richmond location",
];

export default function TryRiskFreeCTA({
  title = "Try a Class Risk-Free",
  description = "Not sure which program is right for your child? Book a trial class and we'll recommend the best program based on your child's age, interests, and experience level.",
  benefits = DEFAULT_BENEFITS,
  ctaLabel = "Book a trial class",
  ctaTo = "/trial-class",
  secondaryHref,
  secondaryLabel = "View schedule",
  programSlug,
}) {
  return (
    <section
      className="rounded-[2.5rem] bg-gradient-to-br from-[#FFFCF7] via-white to-sky-50 border border-slate-200/70 p-8 sm:p-12 lg:p-16 grid lg:grid-cols-12 gap-10 items-center"
      data-testid="try-risk-free"
    >
      <div className="lg:col-span-7">
        <p className="eyebrow text-[#9A3412]">Conversion-friendly</p>
        <h3 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-extrabold text-slate-900 mt-3 leading-[1.06]">
          {title}
        </h3>
        <p className="mt-5 text-slate-600 leading-relaxed max-w-xl">
          {description}
        </p>
        <ul className="mt-6 grid sm:grid-cols-2 gap-2.5 max-w-md">
          {benefits.map((b) => (
            <li key={b} className="flex items-start gap-2 text-sm text-slate-700">
              <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-sky-50">
                <Check className="h-3 w-3 text-[#0369A1]" />
              </span>
              {b}
            </li>
          ))}
        </ul>
      </div>
      <div className="lg:col-span-5 flex flex-col gap-3">
        <Link
          to={ctaTo}
          state={programSlug ? { programSlug } : undefined}
          onClick={() => track("book_trial_clicked", { cta_target: ctaTo, program_slug: programSlug })}
          className="btn-primary justify-center w-full !py-4 text-sm"
          data-testid="try-risk-free-trial-cta"
        >
          {ctaLabel}
          <ArrowUpRight className="h-4 w-4" />
        </Link>
        {secondaryHref && (
          <a
            href={secondaryHref}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-soft justify-center w-full !py-4 text-sm"
            data-testid="try-risk-free-schedule-cta"
          >
            {secondaryLabel}
            <ArrowUpRight className="h-4 w-4" />
          </a>
        )}
        <p className="text-center text-xs text-slate-500 mt-2">
          One-on-one follow-up. No commitment required.
        </p>
      </div>
    </section>
  );
}
